export default function isPattern(value, pattern, inverse) {
  const reg = new RegExp(pattern);

  return inverse ? !reg.test(value) : reg.test(value);
}
